<template>
  <div :class="cn('newsroom-section min-h flex items-center text-white', props.class)">
    <div
      class="md:max-w-large container grid grid-cols-3 items-center gap-10 md:flex md:flex-col md:gap-10 md:py-10 md:*:w-full"
    >
      <div class="flex flex-col gap-8 md:gap-4">
        <span class="text-3xl font-semibold md:leading-none">FINQING out loud</span>

        <p>Our newsroom is your gateway to exploring the latest happenings and achievements.</p>

        <UiButton class="w-fit" variant="alternative" to="https://press.finqai.com"
          >Visit our newsroom</UiButton
        >
      </div>

      <div class="gap-inherit col-span-2 grid grid-cols-2 md:flex md:flex-col">
        <LandingHomeSectionNewsroomCard
          image="homepage/redesign/newsroom/forbes.png"
          title="Here Comes The Big, Strong Agentic AI Wave"
          date="February 5, 2025"
          link="https://www.forbes.com/sites/kolawolesamueladebayo/2025/02/05/here-comes-the-big-strong-agentic-ai-wave/"
        />

        <LandingHomeSectionNewsroomCard
          image="homepage/redesign/newsroom/digital-journel.png"
          title="Did this AI investment platform really beat the S&P 500?"
          date="September 5, 2024"
          link="https://www.digitaljournal.com/tech-science/did-this-ai-investment-platform-really-beat-the-sp-500/article#ixzz8mfy53bS0"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  class?: ClassValue
}>()
</script>

<style lang="scss" scoped>
.newsroom-section {
  background: linear-gradient(0deg, #2e3132 0%, #2e3132 100%);
  min-height: 422px;
}
</style>

<i18n lang="json">
{
  "he": {},
  "en": {}
}
</i18n>
